import React, { FunctionComponent } from 'react';
import classNames from 'classnames';

import { IconProps } from '@hcs/types';

import { addOptionalEngagementProps } from '../utils/engagement-props.utils';

export const useIcon = (
  Svg: FunctionComponent<
    React.SVGProps<SVGSVGElement> & {
      title?: string | undefined;
    }
  >,
  { dataHcName, className, size, color, ...props }: IconProps,
) => {
  const sizeInput = () => {
    switch (size) {
      case Number(size):
        return size;
      case 'xs':
        return 14;
      case 'sm':
        return 16;
      case 'lg':
        return 30;
      case 'xl':
        return 60;
      default:
        return 24; //md is default
    }
  };
  const { ref, ...restProps } = props;
  return (
    <div
      data-hc-name={dataHcName}
      {...addOptionalEngagementProps(restProps)}
      className={classNames('IconContainer', className)}
      style={{
        color: color ? `var(--${color})` : undefined,
        fontSize: sizeInput(),
        width: sizeInput(),
      }}
    >
      <Svg style={{ width: sizeInput() }} {...restProps} />
    </div>
  );
};
